(ns common.permissions.field-permissions
  (:require
   [common.schema.registry :as registry]
   [common.util :as cu]
   [common.roles :as roles]))

(defonce TEAM_PERMISSIONS_NAMESPACE "field-settings.team")

(defn team-configuration-keyword
  [team]
  (keyword TEAM_PERMISSIONS_NAMESPACE
           (str "id-"
                (cond (:db/id team)
                      (:db/id team)
                      (number? team)
                      team))))

(defn permission-order
  [p & [logger]]
  (case p
    :none 0
    :r 1
    :w 2
    :x 3
    (when logger
      (logger (str "Unknown field permission : " p)))))

;; TODO: is this only used from webforms? Is it needed?
(defn write-access?
  [access-permission]
  (case access-permission
    :x true
    :w true
    false))

(defn parse-team-id
  [k]
  (when (= TEAM_PERMISSIONS_NAMESPACE (namespace k))
    #?(:cljs (js/parseInt (subs (name k) 3) 10)
       :clj (Long/parseLong (subs (name k) 3) 10))))

(def NOT-IN-USE-BLOCKED :not-in-use-blocked)
(def NOT-IN-USE :not-in-use)
(def IN-USE :in-use)
(def IN-USE-DISABLED :in-use-disabled)

(def POSITIVE-IN-USE-VALUES #{:field-in-use :in-use :in-use-disabled})
(def NEGATIVE-IN-USE-VALUES #{:field-not-in-use :not-in-use :not-in-use-blocked})

(defn resolve-user-entity-access
  [{:keys [tenant-schema entity-config all-fields-in-use active-teams role read-only?]}]
  (->>
   entity-config
   (reduce-kv
    (fn [m attribute custom-field-configuration]
      (let [field-schema (registry/get-field-schema tenant-schema attribute)
            default-auth (:field/default-authorization field-schema)
            default-admin-access (roles/resolve-role-field-access :role/admin default-auth)
            default-user-access (roles/resolve-role-field-access :role/user default-auth)
            default-ssg-setting (roles/resolve-role-field-access :role/guest-sell-side default-auth)
            default-bsg-setting (roles/resolve-role-field-access :role/guest-buy-side default-auth)
            ;;if currency-symbol, use the corresponding currency attribute's config:
            config-attr (if (cu/currency-symbol? attribute)
                          (cu/currency-symbol->currency attribute)
                          attribute)
            user-access
            (if (or (not (contains? all-fields-in-use config-attr))
                    (contains? NEGATIVE-IN-USE-VALUES
                               (:field-settings/in-use-config custom-field-configuration)))
              :none
              (case role
                ;; always >= max-team-access
                :role/admin default-admin-access
                :role/user (or (some->> active-teams
                                        (mapv team-configuration-keyword)
                                        (mapv (partial get custom-field-configuration))
                                        not-empty
                                        (apply max-key (fn [p]
                                                         (permission-order p nil))))
                               default-user-access)
                :role/guest-buy-side (or (:field-settings/buy-side-guest custom-field-configuration)
                                         default-bsg-setting)
                :role/guest-sell-side (let [ssg-config (:field-settings/sell-side-guest
                                                        custom-field-configuration)]
                                        (or ssg-config
                                            default-ssg-setting))
                :none))
            read-only-filtered-access (cond (not read-only?) user-access
                                            (roles/read-access? user-access) :r
                                            :else :none)]
        ;; If user does not belong to any team -> no access
        (assoc! m attribute (or read-only-filtered-access :none))))
    (transient {}))
   persistent!))

(defn resolve-account-field-permissions
  [tenant-schema
   all-fields-in-use
   tenant-field-configurations
   active-teams
   role
   read-only?
   & [_logger]]
  ;; TODO: once verified - we only need to calculate this for current user
  (->> tenant-field-configurations
       (reduce-kv (fn [m entity-type entity-config]
                    (let [user-access-to-entity
                          (resolve-user-entity-access
                           {:entity-config     entity-config
                            :tenant-schema     tenant-schema
                            :all-fields-in-use all-fields-in-use
                            :active-teams      active-teams
                            :role              role
                            :read-only?        read-only?})]
                      (assoc! m entity-type user-access-to-entity)))
                  (transient {}))
       persistent!))

(defn resolve-field-access
  [user-teams tenant-field-access-config default-user-access & [logger]]
  (if-not (some #{(:field-settings/in-use-config tenant-field-access-config)}
                POSITIVE-IN-USE-VALUES)
    :not-in-use
    (->> user-teams
         (map team-configuration-keyword)
         (map (fn [team-kw]
                (or (get tenant-field-access-config team-kw)
                    default-user-access)))
         (sort-by (fn [p]
                    (permission-order p logger)))
         (last))))
